import { type SearchModuleTranslationKey } from '../types/typedTranslationKeys';
import { PROMPT_NUMBERS, PROMPT_SUGGESTION_COUNT, type PromptNumber } from '../consts/aiSearch';

export type AiPromptSuggestionTranslationKey = Extract<
  SearchModuleTranslationKey,
  `search.aiSearch.promptSuggestionsDropdown.suggestion${PromptNumber}`
>;

export const getRandomNumbersArray = (): PromptNumber[] => {
  const shuffledPromptNumbers = [...PROMPT_NUMBERS];

  for (let index = shuffledPromptNumbers.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    const currentNumber = shuffledPromptNumbers[index];
    const swapNumber = shuffledPromptNumbers[swapIndex];

    if (currentNumber === undefined || swapNumber === undefined) {
      continue;
    }

    shuffledPromptNumbers[index] = swapNumber;
    shuffledPromptNumbers[swapIndex] = currentNumber;
  }

  return shuffledPromptNumbers.slice(0, PROMPT_SUGGESTION_COUNT);
};

export const getAiPromptSuggestionTranslationKey = (suggestionNumber: PromptNumber): AiPromptSuggestionTranslationKey =>
  `search.aiSearch.promptSuggestionsDropdown.suggestion${suggestionNumber}`;

export const getIsAiPromptSearchDisabled = (promptValue: string, temporaryPromptValue: string): boolean =>
  temporaryPromptValue.trim().length < 3 || promptValue.trim() === temporaryPromptValue.trim();
